module.exports = __webpack_public_path__ + "img/pubgm.83b61f4.png";